module.exports = __webpack_public_path__ + "static/media/compact-disc.09be49b8.svg";